import { Message, MessageBox, Notification, Loading } from 'element-ui'

let loadingInstance

export default {
  // 消息提示
  msg(content) {
    Message.info({
      customClass: 'message-class',
      message: content,
      offset: 80,
      center: true
    })
  },
  // 错误消息
  msgError(content) {
    Message.error({
      customClass: 'message-class',
      message: content,
      offset: 80,
      center: true
    })
  },
  // 成功消息
  msgSuccess(content) {
    Message.success({
      customClass: 'message-class',
      message: content,
      offset: 80,
      center: true
    })
  },
  // 警告消息
  msgWarning(content) {
    Message.warning({
      customClass: 'message-class',
      message: content,
      offset: 80,
      center: true
    })
  },
  // 弹出提示
  alert(content) {
    MessageBox.alert(content, '系统提示')
  },
  // 错误提示
  alertError(content) {
    MessageBox.alert(content, '系统提示', { type: 'error' })
  },
  // 成功提示
  alertSuccess(content) {
    MessageBox.alert(content, '系统提示', { type: 'success' })
  },
  // 警告提示
  alertWarning(content) {
    MessageBox.alert(content, '系统提示', { type: 'warning' })
  },
  // 通知提示
  notify(content) {
    Notification.info(content)
  },
  // 错误通知
  notifyError(content) {
    Notification.error(content)
  },
  // 成功通知
  notifySuccess(content) {
    Notification.success(content)
  },
  // 警告通知
  notifyWarning(content) {
    Notification.warning(content)
  },
  // 确认窗体
  confirm(content, title, params) {
    return MessageBox.confirm(content, title || '系统提示', {
      confirmButtonText: params?.confirmButtonText || '确定',
      cancelButtonText: params?.cancelButtonText || '取消',
      type: params?.type || 'warning',
      dangerouslyUseHTMLString: params?.dangerouslyUseHTMLString || false,
      customClass: params?.customClass || '',
      showClose: params?.showClose || false,
      closeOnClickModal: params?.closeOnClickModal || false,
      closeOnPressEscape: params?.closeOnPressEscape || false,
      center: params?.isCenter || false
    })
  },
  // 提交内容
  prompt(content, pattern) {
    return MessageBox.prompt(content, '系统提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: pattern,
      type: 'info'
    })
  },
  // 打开遮罩层
  loading(content) {
    loadingInstance = Loading.service({
      lock: true,
      text: content,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  // 关闭遮罩层
  closeLoading() {
    loadingInstance.close()
  },

  boxCancel(name) {
    return MessageBox.confirm('是否取消' + name + '?', '取消' + name, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
  },

  boxRevoke(name, type) {
    return MessageBox.confirm('是否撤回' + name + '?', '撤回' + name, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type || 'warning'
    })
  },

  reject(name, type, prop) {
    return MessageBox.prompt('请输入驳回原因', '驳回' + name, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /^.+$/,
      inputErrorMessage: '请输入驳回原因',
      type: type || 'warning'
    })
  },

  boxPublish(name, type) {
    return MessageBox.confirm('是否发布' + name + '?', '发布' + name, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type || 'success'
    })
  },

  boxCheck(name, type) {
    return MessageBox.confirm('是否审核' + name + '?', '审核' + name, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type || 'success'
    })
  },

  delete(delName, title) {
    return MessageBox.confirm('是否删除' + delName + '?', title || '系统提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
  }
}
